import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import CountryPicker from './CountryPicker';

/**
 * Coordinates are shown but NEVER edited here. They are looked up on the
 * server from the postcode or address (postcodes.io, then Nominatim), because
 * a hand-typed or model-guessed lat/long is indistinguishable from a correct
 * one until someone drives to it. Correcting the postcode is how you correct
 * the pin.
 */
const StepDetails = ({
  name, setName, country, setCountry, countries,
  address, setAddress, postcode, setPostcode, website, setWebsite,
  latitude, longitude, geoSource,
}) => {
  const hasCoords = latitude != null && longitude != null;

  return (
    <div className="cw-section">
      <p className="cw-section-hint">What course is this? You'll add tees and the scorecard next.</p>

      <div className="cw-field">
        <label>Course name</label>
        <input
          type="text"
          placeholder="e.g. St Andrews Old Course"
          value={name}
          onChange={e => setName(e.target.value)}
          autoFocus
        />
      </div>

      <div className="cw-field">
        <label>Country</label>
        <CountryPicker value={country} onChange={setCountry} countries={countries} />
      </div>

      <div className="cw-field">
        <label>Address <span className="cw-field-opt">optional</span></label>
        <input
          type="text"
          placeholder="e.g. Golf Course Road, Farnham"
          value={address ?? ''}
          onChange={e => setAddress(e.target.value)}
        />
      </div>

      <div className="cw-field-row">
        <div className="cw-field">
          <label>Postcode <span className="cw-field-opt">optional</span></label>
          <input
            type="text"
            placeholder="e.g. GU10 5PF"
            value={postcode ?? ''}
            onChange={e => setPostcode(e.target.value)}
            autoCapitalize="characters"
          />
        </div>
        <div className="cw-field">
          <label>Website <span className="cw-field-opt">optional</span></label>
          <input
            type="text"
            inputMode="url"
            placeholder="e.g. farnhamgolfclub.co.uk"
            value={website ?? ''}
            onChange={e => setWebsite(e.target.value)}
            autoCapitalize="none"
          />
        </div>
      </div>

      {hasCoords ? (
        <div className="cw-geo">
          <FiMapPin size={13} />
          <span className="cw-geo-coords">
            {Number(latitude).toFixed(5)}, {Number(longitude).toFixed(5)}
          </span>
          <a
            className="cw-geo-link"
            href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in Maps
          </a>
          {geoSource && <span className="cw-geo-source">from {geoSource.replace(/_/g, '.')}</span>}
        </div>
      ) : (
        <p className="cw-geo cw-geo--empty">
          <FiMapPin size={13} />
          <span>No map location yet — it's looked up from the postcode when this is saved.</span>
        </p>
      )}
    </div>
  );
};

export default StepDetails;
